import LoginForm from "@components/auth/login-form";
import { Logo } from "@components/icons/new/logo";
import { GetStaticProps } from "next";
import { ROUTES } from "@utils/routes";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getAuthCredentials, isAuthenticated } from "@utils/auth-utils";
import { useRouter } from "next/router";
import React from "react";
import { SwitchLanguage } from "@components/common/switch-language";

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale!, ["common", "form"])),
  },
});

export default function LoginPage() {
  const router = useRouter();
  const { token, permissions } = getAuthCredentials();

  if (isAuthenticated({ token, permissions })) {
    router.replace(ROUTES.DASHBOARD);
  }

  return (
    <div className="flex items-center justify-center h-screen bg-light sm:bg-gray-100">
      <div className="m-auto h-auto w-full bg-light sm:shadow px-8 py-10 rounded w-464">
        <div className="flex justify-between mb-34px">
          <Logo width={134} height={46} />
          <SwitchLanguage url={ROUTES.LOGIN} />
        </div>
        <LoginForm />
      </div>
    </div>
  );
}
